import { SubscriptionTopics } from "../@api/client-api";

export const topicBooleanToStringMap: Record<keyof SubscriptionTopics, string> = {
  leadershipTrends: "Point of View / Top 10 Reads (general leadership)",
  boardGovernance: "Board Governance Quarterly (boards)",
  tmts: " Global Connections (technology, media, telecommunications)",
  hr: "HR Quarterly (human resources)",
};
